import { createUseStyles } from 'react-jss';

import { ViboTheme } from 'types/theme';

const useStyles = createUseStyles((theme: ViboTheme) => ({
  separator: {
    fontSize: '16px',
    lineHeight: '22.67px',
    color: theme.palette.text.secondary,
    textTransform: 'lowercase',
    textAlign: 'center',
    padding: '6.7px 0',

    '@media screen and (min-width: 1441px)': {
      padding: '12.5px 0',
    },
  },
}));

export default useStyles;
